import { z } from 'zod';
import { SortSchema, tableColumnDTOSchema } from './layout-dto';

/**
 * Items view layout DTO
 * Stores layout configuration for the loop-level Items view.
 * One layout per loop (not tied to any specific view or visualization).
 * Shows ALL item levels - no itemLevelId needed.
 */
export const itemsViewLayoutDTOSchema = z.object({
  loopId: z.number().int(),
  organizationId: z.string(),
  columns: z.array(tableColumnDTOSchema),
  sort: SortSchema.optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type ItemsViewLayoutDTO = z.infer<typeof itemsViewLayoutDTOSchema>;

/**
 * Items view layout upsert DTO
 * Used for creating or updating Items view layout.
 */
export const itemsViewLayoutUpsertDTOSchema = z.object({
  columns: z.array(tableColumnDTOSchema).optional(),
  sort: SortSchema.optional(),
});

export type ItemsViewLayoutUpsertDTO = z.infer<typeof itemsViewLayoutUpsertDTOSchema>;
